export default function BeaconService(beaconUrl) {
  const img = document.createElement('img')
  img.src = beaconUrl
  img.width = 1
  img.height = 1
  img.className = 'sr-hidden hidden'
  img.alt = ''
  img.role = 'presentation'
  img.ariaHidden = true
  img.style.cssText = 'display:none;'
  document.body.appendChild(img)
}
